import React from "react";

const Tags = props => {
    const { article } = props;
    return (
        <span>
            {article.title ? article.title : "Powiązane linki: "}
        </span>
    );
};

export default Tags;
